import { render, staticRenderFns } from "./DeliveryProductCreate.vue?vue&type=template&id=438a5a46&scoped=true"
import script from "./DeliveryProductCreate.vue?vue&type=script&lang=js"
export * from "./DeliveryProductCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438a5a46",
  null
  
)

export default component.exports